import React, { useState, useEffect, useMemo } from 'react'
import Card from 'react-bootstrap/Card';
import ReactDataTableBootstrap from '../../Components/ReactDataTableBootstrap/ReactDataTableBootstrap';
import Controllers from '../../Api/Controllers';
import Helpers from '../../Components/Helpers/Helpers';
import { toast } from 'react-toastify'

const HistoryCommisions = _ => {
    const [isProcessing, setIsProccesing] = useState(false)
    const [rows, setRows] = useState({
        total: 0,
        details: [],
        code_money: ''
    })

    useEffect(() => {
        setIsProccesing(true)
        Controllers.report.get_report_commissions_period_by_customers().then(res => {
            setRows(res.data)
        }).catch(req => Helpers.promise.catch({ req, toast }))
            .finally(() => {
                setIsProccesing(false)
            })
    }, [])

    const dtRows = useMemo(() => <ReactDataTableBootstrap
        head={[
            [
                { name: 'name_period', text: 'Periódo', align: 'center' },
                { name: 'name_plan', text: 'Rango', align: 'center' },
                
                { name: 'type_fee', text: 'Régimen', align: 'center' },
                { name: 'subtotal_earnings', text: 'Subtotal', align: 'center', render: r => r.subtotal_earnings ? '$ ' + r.subtotal_earnings : ''},
                { name: 'isr', text: 'ISR', align: 'center', render: r => r.isr ? '$ ' + r.isr : '' },
                { name: 'iva', text: 'IVA', align: 'center', render: r => r.iva ? '$ ' + r.iva : '' },
                { name: 'ret_iva', text: 'RET IVA', align: 'center', render: r => r.ret_iva ? '$ ' + r.ret_iva : '' },
                { name: 'resico', text: 'RESICO', align: 'center', render: r => r.resico ? '$ ' + r.resico : '' },
                { name: 'total', text: 'Total', align: 'center', render: r => r.total ? '$ ' + r.total : '' },

                { name: 'code_money', text: 'Moneda', align: 'center' },
            ],
        ]}
        rows={rows.details}
        pageLength={100}
        isProcessing={isProcessing}
    />, [rows, isProcessing])

    return <>
        <Card>
            <Card.Header className="justify-content-between">
                <span>Historial de Comisiones</span>
            </Card.Header>
            <Card.Body>
                {dtRows}
            </Card.Body>
        </Card>
        {isProcessing ? '' : <div className="d-flex justify-content-center mt-4">
            <div className="alert alert-success text-center">
                <h5>Total de Comisiones: <strong>{rows.code_money} {rows.total}</strong></h5>
            </div>
        </div>}
    </>
}

export default HistoryCommisions